import './text.less'

import React from 'react'
import {LinkType, WysiwygType} from 'types'
import {style} from 'util/style'
import {Title} from 'views/layout/title'
import {Theme} from 'views/theme'

const styles = style('text')

export type TextType = {
	id?: string
	title?: string
	subtitle?: string
	text?: WysiwygType
	links_layout?: 'button' | 'link'
	links?: Array<LinkType>
}

export const Text: React.FC<TextType> = ({
	id,
	title,
	subtitle,
	text,
	links_layout = 'link',
	links
}) => {
	return (
		<div id={id} className={styles()}>
			<Theme.OuterContainer>
				<Theme.Container>
					{(title || subtitle) && (
						<Title
							className={styles('top')}
							title={title}
							subtitle={subtitle}
						/>
					)}
					{text && (
						<div className={styles('text')}>
							<Theme.Wysiwyg>{text}</Theme.Wysiwyg>
						</div>
					)}
					{links_layout === 'button' ? (
						<Theme.ButtonsMap links={links} className={styles('links')} />
					) : (
						<Theme.LinksMap links={links} className={styles('links')} />
					)}
				</Theme.Container>
			</Theme.OuterContainer>
		</div>
	)
}
